export enum ActiveBlock {
  FORM = 'FORM',
  COMPLETE = 'COMPLETE',
}